(() => {
  async function addGift(variantId, threshold) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          _gift: '1',
          _gift_min: String(Number(threshold || 0)),
        },
      }),
    });

    const data = await res.json().catch(() => null);
    return { ok: res.ok, status: res.status, data };
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    return res.json();
  }

  function getRemaining(picker) {
    const max = Number(picker?.dataset?.maxGifts || 0);
    const selected = Number(picker?.dataset?.selectedGifts || 0);
    return Math.max(0, max - selected);
  }

  function setBtn(btn, state) {
    if (!btn.dataset.defaultText) {
      btn.dataset.defaultText =
        btn.getAttribute('data-default-text') ||
        (btn.textContent || '').trim() ||
        'Adicionar';
    }

    if (state === 'loading') {
      btn.disabled = true;
      btn.textContent = 'Adicionando...';
      return;
    }

    if (state === 'added') {
      btn.disabled = true;
      btn.textContent = 'Adicionado';
      btn.classList.add('is-added');
      btn.setAttribute('aria-disabled', 'true');
      return;
    }

    btn.disabled = false;
    btn.classList.remove('is-added');
    btn.removeAttribute('aria-disabled');
    btn.textContent = btn.dataset.defaultText;
  }

  function cartHasGiftProduct(cart, productId) {
    const pid = Number(productId);
    return !!cart?.items?.some((i) => {
      if (Number(i.product_id) !== pid) return false;
      return String(i?.properties?._gift || '') === '1';
    });
  }

  async function markExistingGifts() {
    const cart = await fetchCart();
    if (!cart) return;

    const picker = document.querySelector('.gift-picker');
    if (picker) {
      const selected = (cart.items || []).reduce((acc, it) => {
        return acc + (String(it?.properties?._gift || '') === '1' ? 1 : 0);
      }, 0);
      picker.dataset.selectedGifts = String(selected);
    }

    document.querySelectorAll('[data-gift-card]').forEach((card) => {
      const btn = card.querySelector('[data-gift-add]');
      if (!btn) return;

      const productId = card.dataset.productId;
      if (!productId) return;

      if (cartHasGiftProduct(cart, productId)) setBtn(btn, 'added');
      else setBtn(btn, 'default');
    });
  }

  // ✅ dispara o evento do tema que o cart-drawer.js escuta (CartAddEvent.eventName = 'cart:update')
  function dispatchThemeCartUpdate(cart) {
    try {
      const ev = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart || null,
          sourceId: 'gift-picker',
          data: { source: 'gift-picker' },
        },
      });

      document.dispatchEvent(ev);
      // alguns setups escutam no window também
      window.dispatchEvent(ev);
    } catch (e) {}
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-gift-add]');
    if (!btn) return;
    if (btn.disabled) return;

    e.preventDefault();

    const picker = btn.closest('.gift-picker');
    const card = btn.closest('[data-gift-card]');
    if (!picker || !card) return;

    if (getRemaining(picker) <= 0) return;

    const productId = card.dataset.productId;
    if (!productId) return;

    const threshold = Number(card.dataset.threshold || 0);
    if (!threshold) return;

    const variantEl = card.querySelector('[data-gift-variant]');
    const variantId = variantEl && variantEl.value;
    if (!variantId) return;

    const cartBefore = await fetchCart();
    if (cartHasGiftProduct(cartBefore, productId)) {
      setBtn(btn, 'added');
      return;
    }

    setBtn(btn, 'loading');

    try {
      const r = await addGift(variantId, threshold);

      if (!r.ok) {
        console.warn('[GIFT] erro', r.status, r.data);
        setBtn(btn, 'default');
        return;
      }

      // ✅ pega carrinho real depois do add (evita race no mobile)
      const cartNow = await fetchCart();

      // ✅ avisa o tema pra atualizar/abrir o drawer
      dispatchThemeCartUpdate(cartNow);

      // ✅ atualiza contador/botões do gift-picker
      await markExistingGifts();
    } catch (err) {
      console.warn('[GIFT] erro inesperado', err);
      setBtn(btn, 'default');
    }
  });

  // carrossel
  document.addEventListener('click', (e) => {
    const picker = e.target.closest('.gift-picker');
    if (!picker) return;

    const track = picker.querySelector('[data-gift-track]');
    if (!track) return;

    if (e.target.closest('[data-gift-prev]')) track.scrollBy({ left: -220, behavior: 'smooth' });
    if (e.target.closest('[data-gift-next]')) track.scrollBy({ left: 220, behavior: 'smooth' });
  });

  document.addEventListener('change', (e) => {
    if (e.target && e.target.matches('[data-gift-variant]')) {
      markExistingGifts();
    }
  });

  markExistingGifts();
})();